import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  loadEscolasPorCidade,
  loadEscolasPorCidadesECodCoop,
} from '../../store/modules/EscolasActions';
import {
  loadCidadesByEstadoId,
  loadEstados,
  loadAllEstadosByCoops,
} from '../../store/modules/LogradouroActions';
import { closeModal } from '../../store/modules/ModalActions';
import { getElementID } from '../../utils/HTMLUtils';
import { Col } from '../Col';
import { CustomButton } from '../CustomButton';
import { GenericModal } from '../GenericModal';
import NewAutoCompleteField from '../NewAutoCompleteField/NewAutoCompleteField';
import { Row } from '../Row';
import styles from './SelectSchoolsModal.scss';

const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  loading: false,
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  estadoId: -1,
  estadoUf: null,
  cidadeNome: null,
  cidadeId: -1,
  escola: null,
};

class SelectSchoolsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };

    this.toReturn = this.toReturn.bind(this);
  }

  componentDidMount() {
    if (this.props.estadosByCodCoop) {
      this.props.loadAllEstadosByCoops([this.props.estadosByCodCoop]);
    } else {
      this.props.loadEstados();
    }
  }

  toClose() {
    this.props.closeModal(this.props.modalKey);
  }

  loadCidades(estadoId) {
    if (
      typeof estadoId === 'number' &&
      estadoId > -1 &&
      this.getCidades(this.getUFByEstadoId(estadoId)).length === 0
    ) {
      this.props.loadCidadesByEstadoId(
        estadoId,
        this.getUFByEstadoId(estadoId)
      );
    }
  }

  loadEscolas(cidade) {
    if (this.props.escolasByCodCoop) {
      this.props.loadEscolasPorCidadesECodCoop(
        [cidade],
        this.props.escolasByCodCoop
      );
    } else {
      this.props.loadEscolasPorCidade(cidade);
    }
  }

  reset() {
    this.setState(INITIAL_STATE);
  }

  getTitle() {
    return this.props.languageValues.selectSchoolModalTitle;
  }

  getUFByEstadoId(estadoId) {
    const estados = this.props.estadosByCodCoop
      ? this.props.logradouro.allEstadosByCoops.filter(estado => estado.id === estadoId)
      : this.props.logradouro.estados.filter(estado => estado.id === estadoId);

    return (estados && estados.length > 0) ? estados[0].sigla : '';
  }

  getCidades(uf) {
    if (!uf || uf.length === 0) {
      return [];
    }
    return this.props.logradouro.cidades[uf.toLowerCase()] || [];
  }

  toReturn() {
    this.props.selectedCallback({
      nome: this.state.escola.label,
      id: this.state.escola.value,
      estadoId: this.state.estadoId,
      cidadeNome: this.state.cidadeNome,
    });
    this.toClose();
  }

  getEstadosFieldProps = () => {
    if (this.props.estadosByCodCoop) {
      return {
        placeholder: this.props.logradouro.loadingAllEstadosByCoops
          ? this.props.languageValues.loadingEstados
          : '',
        options: this.props.logradouro.allEstadosByCoops.map((item) => {
          return {
            label: item.nome,
            value: item.id,
            sigla: item.sigla,
          };
        }),
        value: this.state.estadoId,
        onChange: (value) => {
          const currValue = value && value.value > -1 ? value.value : -1;
          this.setState({
            ...this.state,
            estadoId: currValue,
            estadoUf: this.getUFByEstadoId(currValue),
          });
          this.loadCidades(currValue);
        },
        loading: this.props.logradouro.loadingAllEstadosByCoops,
        loadingMessage: this.props.languageValues.loadingEstados,
      };
    }
    return {
      placeholder: this.props.logradouro.loadingEstados
        ? this.props.languageValues.loadingEstados
        : '',
      options: this.props.logradouro.estados.map((item) => {
        return {
          label: item.nome,
          value: item.id,
          sigla: item.sigla,
        };
      }),
      value: this.state.estadoId,
      onChange: (value) => {
        const currValue = value && value.value > -1 ? value.value : -1;
        this.setState({
          ...this.state,
          estadoId: currValue,
          estadoUf: this.getUFByEstadoId(currValue),
        });
        this.loadCidades(currValue);
      },
      loading: this.props.logradouro.loadingEstados,
      loadingMessage: this.props.languageValues.loadingEstados,
    };
  };

  escolasIsLoading = () => {
    if (this.props.escolasByCodCoop) {
      return this.props.escolas.loadingEscolasPorCidadesCoop;
    }
    return this.props.escolas.loadingEscolasPorCidade;
  };

  getEscolas = () => {
    if (this.props.escolasByCodCoop) {
      return this.props.escolas.escolasPorCidadesCoop || [];
    }
    return this.props.escolas.escolasPorCidade || [];
  };

  render() {
    const modalId = getElementID(this.props.id, 'modal');
    return (
      <GenericModal
        id={modalId}
        onClose={() => {
          this.toClose();
        }}
        DialogProps={{
          open: true,
          maxWidth: 'sm',
          classes: { paper: 'modal-escolas' },
          disableBackdropClick: this.state.disableBackdropClick,
          disableEscapeKeyDown: this.state.disableEscapeKeyDown,
        }}
        title={this.getTitle()}
        footerContent={
          <Row className='row-buttons-selecao-escola'>
            <Col cols={[6, 6, 6, 6, 6]}>
              <CustomButton
                id={modalId ? getElementID(modalId, 'cancel') : null}
                className={rootClassName + '-cancel-button'}
                label={this.props.languageValues.cancelButton}
                onClick={() => this.toClose()}
              />
            </Col>
            <Col cols={[6, 6, 6, 6, 6]}>
              <CustomButton
                id={modalId ? getElementID(modalId, 'ok') : null}
                className={rootClassName + '-ok-button'}
                label={this.props.languageValues.selecionarEscolaButton}
                disabled={!this.state.escola}
                onClick={this.toReturn}
              />
            </Col>
          </Row>
        }
      >
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <NewAutoCompleteField
              id={modalId ? getElementID(modalId, 'estado') : null}
              label={this.props.languageValues.estado}
              {...this.getEstadosFieldProps()}
            />
          </Col>
        </Row>
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <NewAutoCompleteField
              id={modalId ? getElementID(modalId, 'cidade') : null}
              label={this.props.languageValues.cidade}
              placeholder={
                this.props.logradouro.loadingCidades
                  ? this.props.languageValues.loadingCidades
                  : this.props.languageValues.digiteCidade
              }
              options={this.getCidades(
                this.getUFByEstadoId(this.state.estadoId)
              ).map((item) => {
                return {
                  label: item.nome,
                  value: item.id,
                };
              })}
              value={this.state.cidadeId}
              onChange={(value) => {
                if (value) {
                  this.setState({
                    ...this.state,
                    cidadeId: value.value,
                    cidadeNome: value.label,
                  });
                  this.loadEscolas(value.label);
                } else {
                  this.setState({
                    ...this.state,
                    cidadeId: -1,
                  });
                }
              }}
              loading={this.props.logradouro.loadingCidades}
              loadingMessage={this.props.languageValues.loadingCidades}
              disabled={
                this.props.logradouro.loadingCidades ||
                this.state.estadoId === -1
              }
            />
          </Col>
        </Row>
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <NewAutoCompleteField
              id={modalId ? getElementID(modalId, 'escola') : null}
              label={this.props.languageValues.escola}
              placeholder={
                this.escolasIsLoading()
                  ? this.props.languageValues.loadingEscolas
                  : this.props.languageValues.digiteEscola
              }
              options={this.getEscolas().map((item) => {
                return {
                  label: item.nome,
                  value: item.id,
                };
              })}
              value={this.state.escola ? this.state.escola.value : null}
              onChange={(value) => {
                if (value) {
                  this.setState({
                    ...this.state,
                    escola: value,
                  });
                } else {
                  this.setState({
                    ...this.state,
                    escola: null,
                  });
                }
              }}
              loading={this.escolasIsLoading()}
              loadingMessage={this.props.languageValues.loadingEscolas}
              disabled={this.escolasIsLoading() || this.state.cidadeId === -1}
            />
          </Col>
        </Row>
      </GenericModal>
    );
  }
}

SelectSchoolsModal.propTypes = {
  id: PropTypes.string,
  selectedCallback: PropTypes.func.isRequired,
  modalKey: PropTypes.string.isRequired,
  estadosByCodCoop: PropTypes.string,
  escolasByCodCoop: PropTypes.string,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  logradouro: state.logradouro,
  escolas: state.escolas,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal,
      loadCidadesByEstadoId,
      loadEstados,
      loadEscolasPorCidade,
      loadEscolasPorCidadesECodCoop,
      loadAllEstadosByCoops,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SelectSchoolsModal);
